import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';

import type { MaterialValuationDto } from './types';

/**
 * Endpoints (backend/src/modules/material_valuations/routes.rs):
 *   GET  /api/monthly-batches/:batchId/monthly-material-valuations  -> list
 *   POST /api/monthly-batches/:batchId/monthly-material-valuations  -> create/recompute
 *   POST /api/monthly-material-valuations/:id/lock                  -> lock
 */

/** Latest valuation for the batch (list is ordered newest-first by backend). */
export const fetchMaterialValuation = async (
  batchId: string,
): Promise<MaterialValuationDto | null> => {
  const res = await apiClient.get<ApiSuccess<MaterialValuationDto[]>>(
    `/monthly-batches/${batchId}/monthly-material-valuations`,
  );
  const rows = res.data.data ?? [];
  return rows[0] ?? null;
};

/** Create or recompute (idempotent) value A. Gated by valuation.market_price.apply. */
export const recomputeMaterialValuation = async (
  batchId: string,
): Promise<MaterialValuationDto> => {
  const res = await apiClient.post<ApiSuccess<MaterialValuationDto>>(
    `/monthly-batches/${batchId}/monthly-material-valuations`,
  );
  return res.data.data;
};

/** Lock the valuation (freeze A). Gated by valuation.confirm. */
export const lockMaterialValuation = async (id: string): Promise<MaterialValuationDto> => {
  const res = await apiClient.post<ApiSuccess<MaterialValuationDto>>(
    `/monthly-material-valuations/${id}/lock`,
  );
  return res.data.data;
};
